import { AppCard } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import Translator from '../../../components/helpers/Translator';
import _ from 'lodash';
import errorHandler from '@/layout/components/error/ErrorHandler';

const BlockChangeOptions = () => {
  const dispatch = useDispatch();
  const { page } = useParams();
  const pagination = useSelector((state) => state.currentPage?.pagination);
  const checkedResourcesBlockChange = useSelector(
    (state) => state.currentPage?.checkedResourcesBlockChange,
  );
  const resourceObligationsPage = useSelector(
    (state) => state.currentPage?.resourceObligationsPage,
  );

  const handleSelectAllPage = async () => {
    try {
      const tempChecked =
        _.union(
          checkedResourcesBlockChange,
          resourceObligationsPage[page - 1],
        ) || resourceObligationsPage[page - 1];
      dispatch(
        currentPageAction.change(
          'checkedResourcesBlockChange',
          tempChecked,
          true,
        ),
      );
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  const handleSelectAll = async () => {
    try {
      let tempAll = [];
      resourceObligationsPage.forEach((e) => {
        tempAll = [...e, ...tempAll];
      });
      dispatch(
        currentPageAction.change('checkedResourcesBlockChange', tempAll, true),
      );
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  const handleInvertSelectPage = async () => {
    try {
      const tempInverted = resourceObligationsPage[page - 1].filter(
        (e) => !checkedResourcesBlockChange?.includes(e),
      );
      const removePage = _.differenceWith(
        checkedResourcesBlockChange || [],
        resourceObligationsPage[page - 1],
        _.isEqual,
      );
      const inverted = _.union(removePage, tempInverted);
      dispatch(
        currentPageAction.change('checkedResourcesBlockChange', inverted, true),
      );
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  const handleInvertSelectAll = async () => {
    try {
      let tempAll = [];
      resourceObligationsPage.forEach((e) => {
        tempAll = [...e, ...tempAll];
      });
      const inverted = tempAll.filter(
        (e) =>
          checkedResourcesBlockChange &&
          !checkedResourcesBlockChange.includes(e),
      );
      dispatch(
        currentPageAction.change('checkedResourcesBlockChange', inverted, true),
      );
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  const handleDeselectAll = async () => {
    try {
      dispatch(
        currentPageAction.change('checkedResourcesBlockChange', [], true),
      );
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  if (!pagination) return <></>;

  return (
    <AppCard>
      <span
        className="btn btn-sm btn-outline-light mr-2"
        onClick={() => handleSelectAllPage()}
      >
        <Translator
          file="module-legalCompliance"
          name="select.all.current.page"
        />
      </span>
      <span
        className="btn btn-sm btn-outline-light mr-2"
        onClick={() => handleSelectAll()}
      >
        <Translator
          file="module-legalCompliance"
          name="select.all.current.plant"
        />
      </span>
      <span
        className="btn btn-sm btn-outline-light mr-2"
        onClick={() => handleInvertSelectPage()}
      >
        <Translator
          file="module-legalCompliance"
          name="invert.current.page.selection"
        />
      </span>
      <span
        className="btn btn-sm btn-outline-light mr-2"
        onClick={() => handleInvertSelectAll()}
      >
        <Translator
          file="module-legalCompliance"
          name="invert.current.plant.selection"
        />
      </span>
      <span
        className="btn btn-sm btn-outline-light mr-2"
        onClick={() => handleDeselectAll()}
      >
        <Translator file="module-legalCompliance" name="unselect.all" />
      </span>
      <br />
      <Translator
        file="module-legalCompliance"
        name="selected.obligations.of.all"
        variables={{
          selected: checkedResourcesBlockChange
            ? checkedResourcesBlockChange.length
            : 0,
          total: pagination.totalCount,
        }}
        isHtml
      />
    </AppCard>
  );
};

export default BlockChangeOptions;
